<div class="container-fluid">
  <div class="d-flex flex-column flex-sm-row">
    <mat-form-field>
      <mat-icon matPrefix color="primary">search</mat-icon>
      <input matInput (keyup)="applyFilter($event.target.value)" placeholder="Rechercher" />
    </mat-form-field>
    <mat-slide-toggle (change)="toggleDisplayColumns()" [checked]="displayFullColumns" class="m-3">Afficher toutes
      colonnes</mat-slide-toggle>
    <span class="spacer"></span>
    <button mat-mini-fab appTooltip="Ajouter une maintenance" class="ml-auto m-3 white" color="primary" (click)="add()">
      <mat-icon aria-label="Ajouter une maintenance">add</mat-icon>
    </button>
  </div>
  <div id="attributeGroup" [class]="tableClass">
    <table mat-table [dataSource]="dataSource" matSort>
      <ng-container matColumnDef="summary">
        <th mat-header-cell *matHeaderCellDef mat-sort-header>Libellé</th>
        <td mat-cell *matCellDef="let row" class="main">{{ row.summary }}</td>
      </ng-container>
      <ng-container matColumnDef="type">
        <th mat-header-cell *matHeaderCellDef mat-sort-header>Type</th>
        <td mat-cell *matCellDef="let row">{{ row.type }}</td>
      </ng-container>
      <ng-container matColumnDef="frequency">
        <th mat-header-cell *matHeaderCellDef mat-sort-header>Fréquence</th>
        <td mat-cell *matCellDef="let row">{{ row.frequency }}</td>
      </ng-container>
      <ng-container matColumnDef="energyImpact">
        <th mat-header-cell *matHeaderCellDef mat-sort-header>Impact énergétique ?</th>
        <td mat-cell *matCellDef="let row" class="no-mobile">{{ row.maint.energyImpact | booleanFormat }}</td>
      </ng-container>
      <ng-container matColumnDef="description">
        <th mat-header-cell *matHeaderCellDef mat-sort-header>Description</th>
        <td mat-cell *matCellDef="let row">{{ row.maint.description }}</td>
      </ng-container>
      <ng-container matColumnDef="propertyTypes">
        <th mat-header-cell *matHeaderCellDef mat-sort-header>Types de biens</th>
        <td mat-cell *matCellDef="let row">{{ row.propertyTypes?.length == 0 ? 'Tous' : (row.propertyTypes |
          commaStringArray) }}</td>
      </ng-container>
      <ng-container matColumnDef="conditions">
        <th mat-header-cell *matHeaderCellDef mat-sort-header>Conditions</th>
        <td mat-cell *matCellDef="let row">
          <ul *ngIf="row.conditions?.length > 0; else noCondition" class="m-0 p-0">
            <li *ngFor="let condition of row.conditions">
              {{ condition }}
            </li>
          </ul>
          <ng-template #noCondition>Tous</ng-template>
        </td>
      </ng-container>
      <ng-container matColumnDef="actions">
        <th mat-header-cell *matHeaderCellDef>Actions</th>
        <td mat-cell *matCellDef="let row">
          <button mat-icon-button [matMenuTriggerFor]="actions" [matMenuTriggerData]="{data:row}">
            <mat-icon>more_vert</mat-icon>
          </button>
        </td>
      </ng-container>

      <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
      <tr mat-row *matRowDef="let row; columns: displayedColumns"></tr>
    </table>

    <mat-paginator [pageSize]="paging.pagingPageSize" [pageSizeOptions]="paging.pagingPageSizeOptions"
      showFirstLastButtons></mat-paginator>
  </div>
</div>

<mat-menu #actions="matMenu">
  <ng-template matMenuContent let-row="data">
    <ul class="menu-actions">
      <li>
        <a (click)="edit(row.maint)"><mat-icon color="primary">create</mat-icon><span class="text">Modifier la
            maintenance</span></a>
      </li>
      <li>
        <a (click)="confirmDelete(row.maint)">
          <mat-icon color="primary">delete_forever</mat-icon>
          <span class="text">Supprimer la maintenance</span>
        </a>
      </li>
    </ul>
  </ng-template>
</mat-menu>
